if (!customElements.get('countries-covered-popup')) {
  customElements.define(
    'countries-covered-popup',
    class CountriesCoveredPopup extends HTMLElement {
      constructor() {
        super();
        this.mobileTrigger = this.querySelector('.countries__covered-container');
        this.openBtn = this.querySelector('.countries__covered-button');
        this.popupOverlay = this.querySelector('.countries-popup__overlay');
        this.popupPanel = this.querySelector('.countries-popup__panel');
        this.closeBtn = this.querySelector('.countries-popup__close');
        this.swipeHandle = this.querySelector('.countries-popup__header');
        this.searchInput = this.querySelector('.countries-popup__search-input');
        this.countryItems = this.querySelectorAll('.countries-popup__item');
        this.countryItemContainer = this.querySelector('.countries-popup__list');
        this.noResults = this.querySelector('.countries-popup__no-results');
        this.onSearchInput = this.handleSearchInput.bind(this);
        this.onMobileTriggerKeydown = this.handleMobileTriggerKeydown.bind(this);
        this.controller = null;
      }

      connectedCallback() {
        const init = () => {
          this.mobileTrigger?.setAttribute('role', 'button');
          this.mobileTrigger?.setAttribute('tabindex', '0');
          this.mobileTrigger?.setAttribute('aria-haspopup', 'dialog');
          this.mobileTrigger?.addEventListener('keydown', this.onMobileTriggerKeydown);

          this.controller = window.createBacksheetController({
            host: this,
            overlay: this.popupOverlay,
            panel: this.popupPanel,
            closeBtn: this.closeBtn,
            swipeHandle: this.swipeHandle,
            openTriggers: this.mobileTrigger ? [this.mobileTrigger] : [],
            visibleClass: 'is-visible',
            moveBackDelay: 300,
            onOpen: this.resetSearchState.bind(this),
          });
          this.controller.bind();
          this.searchInput?.addEventListener('input', this.onSearchInput);
        };

        document.readyState === 'loading'
          ? document.addEventListener('DOMContentLoaded', init, { once: true })
          : init();
      }

      handleMobileTriggerKeydown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        this.controller?.open();
      }

      handleSearchInput(event) {
        this.countryItemContainer.classList.remove('hidden');
        const query = event.target.value.trim().toLowerCase();
        let visibleCount = 0;

        this.countryItems.forEach((item) => {
          const country = item.dataset.country || '';
          const isVisible = !query || country.includes(query);
          item.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        if (!this.noResults) return;
        this.noResults.classList.toggle('is-visible', visibleCount === 0);
        if (visibleCount === 0) {
          this.countryItemContainer.classList.add('hidden');
        }
      }

      resetSearchState() {
        if (this.searchInput) {
          this.searchInput.value = '';
        }

        this.countryItems.forEach((item) => {
          item.hidden = false;
        });

        this.noResults?.classList.remove('is-visible');
        this.countryItemContainer.classList.remove('hidden');
      }

      disconnectedCallback() {
        this.controller?.unbind();
        this.searchInput?.removeEventListener('input', this.onSearchInput);
        this.mobileTrigger?.removeEventListener('keydown', this.onMobileTriggerKeydown);
      }
    },
  );
}
